import { ThemeColor } from '@/enums'
import { ifNotProps, themeColor, themeTransition, toThemePixels } from '@/utils'
import styled, { css } from 'styled-components'
import { ifNotProp, ifProp } from 'styled-tools'
import { Square } from '../../styled'

const checkedStyles = css`
  border-color: ${themeColor(ThemeColor.b100)};
`

const unCheckedStyles = css`
  border-color: ${themeColor(ThemeColor.b30)};
`

const hoverStyles = css`
  &:hover {
    border-color: ${ifNotProp('checked', themeColor(ThemeColor.b100))};
  }
`

export const InnerContainer = styled(Square).attrs({
  $size: 16,
})<{
  checked?: boolean
  disabled?: boolean
  error?: boolean
}>`
  cursor: pointer;
  border: 1px solid transparent;
  ${ifProp('checked', checkedStyles, unCheckedStyles)};
  background: ${themeColor(ThemeColor.b10)};
  border-color: ${ifProp('error', themeColor(ThemeColor.danger2))};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: ${themeTransition()};

  ${ifNotProps(['disabled', 'error'], hoverStyles)}
`

export const OuterContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${toThemePixels(1.5)};
  width: fit-content;
`

export const CheckedCircle = styled(Square).attrs({ $size: 8 })`
  background: ${themeColor(ThemeColor.b100)};
  border-radius: 50%;
`
